import { render, staticRenderFns } from "./VipPage.vue?vue&type=template&id=73cb2e02&scoped=true&"
import script from "./VipPage.vue?vue&type=script&lang=js&"
export * from "./VipPage.vue?vue&type=script&lang=js&"
import style0 from "./VipPage.vue?vue&type=style&index=0&id=73cb2e02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cb2e02",
  null
  
)

export default component.exports